import React from "react";
import Navbar from "../Navbar";
import { Helmet } from "react-helmet";
import Footer from '../components/Footer';
import CookiesBanner from '../components/CookiesBanner';

function TerminosCondiciones() {
  return (
    <>
    <Helmet>
        <title>Términos y Condiciones</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Navbar />
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto", lineHeight: "1.6",fontSize: "16px" }}>
      <h1>Términos y Condiciones del Servicio</h1>

      <p>
  Al acceder y utilizar <strong>www.avisamesibaja.com</strong>, ya sea como visitante o como usuario registrado, aceptas expresamente los presentes Términos y Condiciones. Si no estás de acuerdo con alguna parte de los mismos, por favor no utilices el sitio web.
</p>


      <h2>Uso del servicio</h2>
      <p>
        Debes registrarte con un correo electrónico válido o cuenta de Google para acceder al seguimiento de precios y alertas.
      </p>

      <h2>Exactitud de precios</h2>
      
      <p>
  La información de precios y disponibilidad de productos se obtiene de fuentes externas (Amazon). Aunque nos esforzamos por mostrar datos precisos y actualizados, no podemos garantizar su exactitud o disponibilidad en todo momento.
</p>

      <h2>Alertas por email</h2>
      <p>
        Recibirás emails cuando los productos que sigues bajen de precio. Puedes cancelar estas alertas desde tu cuenta en cualquier momento.
      </p>
<h2>Acceso gratuito</h2>
<p>
  Actualmente, todos los servicios de Avísame Si Baja son gratuitos. No solicitamos información de pago y no se realiza ningún cargo al usuario.
</p>


<h2>Cancelación y baja</h2>
<p>
  Puedes darte de baja eliminando tu cuenta desde tu perfil o contactando con{" "}
  <a href="mailto:info@avisamesibaja.com">info@avisamesibaja.com</a>.
</p>
<p>
  Actualmente, el servicio es completamente gratuito, por lo que no aplica el derecho de desistimiento recogido en la normativa de consumo.
</p>

      <h2>Uso fraudulento</h2>
      <p>
  Cualquier uso del servicio que se considere fraudulento, abusivo, contrario a la buena fe o que infrinja las leyes aplicables podrá derivar en la suspensión temporal o eliminación definitiva de la cuenta del usuario, sin previo aviso.
</p>



      <h2>Cláusula sobre uso de datos personales</h2>
      <p>
  La gestión de tus datos personales se realiza conforme a nuestra <a href="/politica-privacidad">Política de Privacidad</a>. Al registrarte, aceptas expresamente el tratamiento de tus datos para prestarte el servicio.
</p>

      

      <h2>Ámbito territorial del servicio</h2>
      <p>
        Este servicio está dirigido exclusivamente a usuarios residentes en España y se rige por la legistación española. No nos hacemos responsables ni garantizamos el cumplimiento normativo legal fuera del territorio español.
      </p>

      <h2>Posibles campañas publicitarias futuras</h2>
      <p>
        En caso de realizar en el futuro campañas publicitarias online o remarketing, informaremos previamente en esta política, solicitando en tal caso tu consentimiento explícito mediante la aceptación de cookies publicitarias.
      </p>
      <p>
  Cualquier campaña publicitaria futura que implique seguimiento o personalización requerirá tu consentimiento explícito mediante la aceptación de cookies publicitarias.
</p>

    </div>
    <Footer />
      <CookiesBanner />
    </>
  );
}

export default TerminosCondiciones;
